import React, { useEffect, useState } from "react";
import { Row, Col, Checkbox, Table, Switch, Tooltip } from "antd";
import RequestHandler from "util/RequestHandler";
import { BarsOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import { RowHelper } from "util/TableHelper";
const AccountTransactionRole = () => {
  const [tableRoles, setTableRoles] = useState({});
  const [tableRolesDigit, setTableRolesDigit] = useState({});
  const [tableRolesTenantAccount, setTableRolesTenantAccount] = useState({});
  const [tableIbanShowInColumn, setTableIbanShowInColumn] = useState({});
  const [tableRolesTenantParameter, setTableRolesTenantParameter] = useState(
    {}
  );
  const [isFull, setIsFull] = useState(false);
  const [isFullDigit, setIsFullDigit] = useState(false);
  const [isFullTenantAccount, setIsFullTenantAccount] = useState(false);
  const [isFullIbanShowInColumn, setFullIbanShowInColumn] = useState(false);
  const [isFullTenantParameter, setIsFullTenantParameter] = useState(false);

  useEffect(() => {
    loadData();
    loadDataDigit();
    loadTenantAccountData();
    loadIbanShowInColumn();
    loadTenantParameterData();
  }, []);

  const loadData = () => {
    RequestHandler.get(`/TenantUserParameter/GetTransactionTableRole`).then(
      (response) => {
        if (response.success) {
          if (response.data.tenantIsKobi) {
            delete response.data.isBalanceAfterTransactionShow;
          }

          const checkboxProps = Object.keys(response.data ?? {}).filter(
            (key) =>
              key.startsWith("is")
          );
          if (
            checkboxProps.length === 0 ||
            checkboxProps.some((key) => !response.data[key])
          ) {
            setIsFull(false);
          } else {
            setIsFull(true);
          }

          setTableRoles(response.data ?? {});
        }
      }
    );
  };

  const loadDataDigit = () => {
    RequestHandler.get(`/TenantUserParameter/GetDigitParameter`).then(
      (response) => {
        if (response.success) {
          const checkboxProps = Object.keys(response.data ?? {}).filter((key) =>
            key.startsWith("isDigit")
          );
          if (
            checkboxProps.length === 0 ||
            checkboxProps.some((key) => !response.data[key])
          ) {
            setIsFullDigit(false);
          } else {
            setIsFullDigit(true);
          }

          setTableRolesDigit(response.data ?? {});
        }
      }
    );
  };
  const loadTenantAccountData = () => {
    RequestHandler.get(
      `/TenantAccountParameter/GetTenantAccountParameter`
    ).then((response) => {
      if (response.success) {
        const checkboxProps = Object.keys(response.data ?? {}).filter(
          (key) =>
            key.startsWith("isBlockedBalance") ||
            key.startsWith("isAvailableBalance") ||
            key.startsWith("isAvailableCreditBalance")
        );
        if (
          checkboxProps.length === 0 ||
          checkboxProps.some((key) => !response.data[key])
        ) {
          setIsFullTenantAccount(false);
        } else {
          setIsFullTenantAccount(true);
        }

        setTableRolesTenantAccount(response.data ?? {});
      }
    });
  };

  const loadTenantParameterData = () => {
    RequestHandler.get(`/TenantParameter/GetPosTransactionCardNumber`).then(
      (response) => {
        if (response.success) {
          const checkboxProps = Object.keys(response.data ?? {}).filter((key) =>
            key.startsWith("isPosTransactionCardNumberShowInColumn")
          );
          if (
            checkboxProps.length === 0 ||
            checkboxProps.some((key) => !response.data[key])
          ) {
            setIsFullTenantParameter(false);
          } else {
            setIsFullTenantParameter(true);
          }
          setTableRolesTenantParameter(response.data ?? {});
        }
      }
    );
  };

  const loadIbanShowInColumn = () => {
    RequestHandler.get(`/TenantUserParameter/GetTransactionTableRole`).then(
      (response) => {
        if (response.success) {
          const allCheckboxProps = Object.keys(response.data ?? {}).filter(
            (key) => key.startsWith("isIbanShowInColumn")
          );

          if (
            allCheckboxProps.length === 0 ||
            allCheckboxProps.some((key) => !response.data[key])
          ) {
            setFullIbanShowInColumn(false);
          } else {
            setFullIbanShowInColumn(true);
          }

          setTableIbanShowInColumn(response.data ?? {});
        }
      }
    );
  };

  const onChangeSingle = (properyName, value) => {
    debugger;
    tableRoles[properyName] = value;
    RequestHandler.post(
      "/TenantUserParameter/AddTransactionTableRoles",
      tableRoles
    ).then((response) => {
      if (response.success) {
        loadData();
      }
    });
  };

  const onChangeFull = (value) => {
    debugger
    Object.keys(tableRoles)
      .filter(
        (key) => key.startsWith("is")
      )
      .forEach((key) => {
        tableRoles[key] = value;
      });

    RequestHandler.post(
      "/TenantUserParameter/AddTransactionTableRoles",
      tableRoles
    ).then((response) => {
      if (response.success) {
        loadData();
      }
    });
  };

  const onChangeSingleTenantAccount = (properyName, value) => {
    tableRolesTenantAccount[properyName] = value;
    RequestHandler.post(
      "/TenantAccountParameter/AddTenantAccountParameter",
      tableRolesTenantAccount
    ).then((response) => {
      if (response.success) {
        loadTenantAccountData();
      }
    });
  };

  const onChangeFullTenantAccount = (value) => {
    Object.keys(tableRolesTenantAccount)
      .filter(
        (key) =>
          key.startsWith("isBlockedBalance") ||
          key.startsWith("isAvailableBalance") ||
          key.startsWith("isAvailableCreditBalance")
      )

      .forEach((key) => {
        tableRolesTenantAccount[key] = value;
      });

    RequestHandler.post(
      "/TenantAccountParameter/AddTenantAccountParameter",
      tableRolesTenantAccount
    ).then((response) => {
      if (response.success) {
        loadTenantAccountData();
      }
    });
  };

  const onChangeSingleShowIbanInColumn = (properyName, value) => {
    tableIbanShowInColumn[properyName] = value;
    RequestHandler.post(
      "/TenantUserParameter/AddTransactionTableRoles",
      tableIbanShowInColumn
    ).then((response) => {
      if (response.success) {
        loadIbanShowInColumn();
      }
    });
  };

  const onChangeFullShowIbanInColumn = (value) => {
    Object.keys(tableIbanShowInColumn)
      .filter((key) => key.startsWith("isIbanShowInColumn"))
      .forEach((key) => {
        tableIbanShowInColumn[key] = value;
      });

    RequestHandler.post(
      "/TenantUserParameter/AddTransactionTableRoles",
      tableIbanShowInColumn
    ).then((response) => {
      if (response.success) {
        loadIbanShowInColumn();
      }
    });
  };

  const onChangeSingleTenantParameter = (properyName, value) => {
    tableRolesTenantParameter[properyName] = value;
    RequestHandler.post(
      "/TenantParameter/UpdatePosTransactionCardNumber",
      tableRolesTenantParameter
    ).then((response) => {
      if (response.success) {
        loadTenantParameterData();
      }
    });
  };

  const onChangeFullTenantParameter = (value) => {
    Object.keys(tableRolesTenantParameter)
      .filter((key) => key.startsWith("isPosTransactionCardNumberShowInColumn"))
      .forEach((key) => {
        tableRolesTenantParameter[key] = value;
      });

    RequestHandler.post(
      "/TenantParameter/UpdatePosTransactionCardNumber",
      tableRolesTenantParameter
    ).then((response) => {
      if (response.success) {
        loadTenantParameterData();
      }
    });
  };

  const onChangeSingleDigit = (properyName, value) => {
    tableRolesDigit[properyName] = value;
    RequestHandler.post(
      "/TenantUserParameter/AddDigitParameters",
      tableRolesDigit
    ).then((response) => {
      if (response.success) {
        loadDataDigit();
      }
    });
  };

  const onChangeFullDigit = (value) => {
    Object.keys(tableRolesDigit)
      .filter((key) => key.startsWith("isDigit"))
      .forEach((key) => {
        tableRolesDigit[key] = value;
      });

    RequestHandler.post(
      "/TenantUserParameter/AddDigitParameters",
      tableRolesDigit
    ).then((response) => {
      if (response.success) {
        loadDataDigit();
      }
    });
  };
  const dataSource = [
    {
      isBranchShow: tableRoles.isBranchShow,
      isIbanShow: tableRoles.isIbanShow,
      isTenantIbanShow: tableRoles.isTenantIbanShow,
      isAdditionalDescriptionShow: tableRoles.isAdditionalDescriptionShow,
      isBalanceAfterTransactionShow: tableRoles.isBalanceAfterTransactionShow,
      isFirmNameShow: tableRoles.isFirmNameShow,
      isDescriptionShow: tableRoles.isDescriptionShow,
      isAccountNameShow: tableRoles.isAccountNameShow,
      isNoteShow: tableRoles.isNoteShow,
      isTransactionTags: tableIbanShowInColumn.isTransactionTags,
      isCurrencyShow: tableRoles.isCurrencyShow,
      isVknTcknShow: tableRoles.isVknTcknShow,
      isTransactionTypeShow: tableRoles.isTransactionTypeShow,
      isSenderNameShow: tableRoles.isSenderNameShow,
      isReceiptShow: tableRoles.isReceiptShow,
      isIbanShowInColumn:tableRoles.isIbanShowInColumn
    },
  ];
  const columns = [
    {
      title: "Şube",
      dataIndex: "isBranchShow",
      render: (text, record) => (
        <Switch
          checked={record.isBranchShow}
          onChange={(e) => onChangeSingle("isBranchShow", e)}
        />
      ),
    },
    {
      title: "Hesap Adı",
      dataIndex: "isAccountNameShow",
      render: (text, record) => (
        <Switch
          checked={record.isAccountNameShow}
          onChange={(e) => onChangeSingle("isAccountNameShow", e)}
        />
      ),
    },
    {
      title: "Iban / Hesap Numarası",
      dataIndex: "isTenantIbanShow",
      render: (text, record) => (
        <Switch
          checked={record.isTenantIbanShow}
          onChange={(e) => onChangeSingle("isTenantIbanShow", e)}
        />
      ),
    },
    {
      title: "Karşı IBAN / Hesap Numarası",
      dataIndex: "isIbanShowInColumn",
      render: (text, record) => (
        <Switch
          checked={record.isIbanShowInColumn}
          onChange={(e) => onChangeSingle("isIbanShowInColumn", e)}
        />
      ),
    },
    {
      title: "İşlem Sonrası Bakiye",
      dataIndex: "isBalanceAfterTransactionShow",
      render: (text, record) => (
        <Switch
          checked={record.isBalanceAfterTransactionShow}
          onChange={(e) => onChangeSingle("isBalanceAfterTransactionShow", e)}
        />
      ),
    },
    {
      title: "Döviz",
      dataIndex: "isCurrencyShow",
      render: (text, record) => (
        <Switch
          checked={record.isCurrencyShow}
          onChange={(e) => onChangeSingle("isCurrencyShow", e)}
        />
      ),
    },
    {
      title: "Açıklama",
      dataIndex: "isDescriptionShow",
      render: (text, record) => (
        <Switch
          checked={record.isDescriptionShow}
          onChange={(e) => onChangeSingle("isDescriptionShow", e)}
        />
      ),
    },
    {
      title: "Bayi Adı",
      dataIndex: "isFirmNameShow",
      render: (text, record) => (
        <Switch
          checked={record.isFirmNameShow}
          onChange={(e) => onChangeSingle("isFirmNameShow", e)}
        />
      ),
    },
    {
      title: "Etiket",
      dataIndex: "isTransactionTags",
      render: (text, record) => (
        <Switch
          checked={record.isTransactionTags}
          onChange={(e) => onChangeSingle("isTransactionTags", e)}
        />
      ),
    },
    {
      title: "Not",
      dataIndex: "isNoteShow",
      render: (text, record) => (
        <Switch
          checked={record.isNoteShow}
          onChange={(e) => onChangeSingle("isNoteShow", e)}
        />
      ),
    },
  ];
  const detailColumns = [
    {
      title: "Karşı Iban",
      dataIndex: "isIbanShow",
      render: (text, record) => (
        <Switch
          checked={record.isIbanShow}
          onChange={(e) => onChangeSingle("isIbanShow", e)}
        />
      ),
    },
    {
      title: "Vkn / T.C. No",
      dataIndex: "isVknTcknShow",
      render: (text, record) => (
        <Switch
          checked={record.isVknTcknShow}
          onChange={(e) => onChangeSingle("isVknTcknShow", e)}
        />
      ),
    },
    {
      title: "İşlem Tipi",
      dataIndex: "isTransactionTypeShow",
      render: (text, record) => (
        <Switch
          checked={record.isTransactionTypeShow}
          onChange={(e) => onChangeSingle("isTransactionTypeShow", e)}
        />
      ),
    },
    {
      title: "Gönderen Adı",
      dataIndex: "isSenderNameShow",
      render: (text, record) => (
        <Switch
          checked={record.isSenderNameShow}
          onChange={(e) => onChangeSingle("isSenderNameShow", e)}
        />
      ),
    },
    {
      title: "Dekont No",
      dataIndex: "isReceiptShow",
      render: (text, record) => (
        <Switch
          checked={record.isReceiptShow}
          onChange={(e) => onChangeSingle("isReceiptShow", e)}
        />
      ),
    },
    {
      title: "Ek Açıklama",
      dataIndex: "isAdditionalDescriptionShow",
      render: (text, record) => (
        <Switch
          checked={record.isAdditionalDescriptionShow}
          onChange={(e) => onChangeSingle("isAdditionalDescriptionShow", e)}
        />
      ),
    },
  ];
  const FormItemLabelWithTooltip = ({ label, tooltip }) => {
    return (
      <>
        {label}{" "}
        <Tooltip title={tooltip}>
          <QuestionCircleOutlined
            className="gx-text-blue"
            style={{ marginLeft: 5, fontSize: "120%" }}
          />
        </Tooltip>
      </>
    );
  };
  return (
    <div>
      <Row>
        <Col
          style={{ paddingBottom: 60 }}
          xl={24}
          lg={24}
          md={24}
          sm={12}
          xs={24}
        >
          <p style={{ fontSize: "120%" }}>
            <BarsOutlined /> HESAP HAREKETLERİ KOLON PARAMETRELERİ
            <FormItemLabelWithTooltip
              tooltip={
                <>
                  <p>
                    <strong>Seçenek aktif edilirse:</strong>
                    <ul>
                      <li>
                        Hesap Hareketleri ekranında ilgili değer/ler tabloda ya
                        da detay alanında görüntülenir.
                      </li>
                    </ul>
                  </p>
                  <p>
                    <strong>Pasif edilirse:</strong>
                    <ul>
                      <li>
                        Hesap Hareketleri ekranında ilgili değer/ler direkt
                        kaldırılır, tabloda ya da detay alanında görüntülenmez.
                      </li>
                    </ul>
                  </p>
                </>
              }
            />
          </p>
        </Col>
        <Col
          style={{ textAlign: "right", marginBottom: 30 }}
          xl={12}
          lg={12}
          md={12}
          sm={12}
          xs={12}
        >
          Tümünü Seç :
        </Col>
        <Col
          style={{ textAlign: "left", marginBottom: 30 }}
          xl={12}
          lg={12}
          md={12}
          sm={12}
          xs={12}
        >
          <Checkbox
            checked={isFull}
            onChange={(e) => onChangeFull(e.target.checked)}
          />
        </Col>
        <Table defaultExpandAllRows 
          className="transaction-role-table"
          dataSource={dataSource}
          columns={columns}
          style={{
            margin: "auto",
            width: "80%",
          }}
          expandable={{
            expandedRowRender: (data) => (
              <div>
                {detailColumns.map((column, index) => (
                  <div
                    key={index}
                    style={{ display: "flex", marginBottom: "0.5em" }}
                  >
                    <div style={{ flex: "0 0 130px", fontWeight: "bold" }}>
                      {column.title}
                    </div>
                    <div>
                      {column.render
                        ? column.render(data[column.dataIndex], data, index)
                        : data[column.dataIndex]}
                    </div>
                  </div>
                ))}
              </div>
            ),
          }}
        />

        <Col
          style={{ paddingBottom: 60,marginTop:70 }}
          xl={24}
          lg={24}
          md={24}
          sm={12}
          xs={24}
        >
          <p style={{ fontSize: "120%" }}>
            <BarsOutlined /> EKRAN KÜSÜRAT GÖSTERİMİ
            <FormItemLabelWithTooltip
              tooltip={
                <>
                  <p>
                    <strong>Seçenek aktif edilirse:</strong>
                    <ul>
                      <li>
                      Seçilen ekranlarda küsürat bilgileri ile birlikte bakiyeler görüntülenir. 
                      </li>
                    </ul>
                  </p>
                  <p>
                    <strong>Pasif edilirse:</strong>
                    <ul>
                      <li>
                      Seçilen ekranlarda küsürat bilgisi, bakiyelerde görüntülenmez.
                      </li>
                    </ul>
                  </p>
                </>
              }
            />
          </p>
        </Col>
        <Col
          style={{ textAlign: "right", marginBottom: 30 }}
          xl={12}
          lg={12}
          md={12}
          sm={12}
          xs={12}
        >
          Tümünü Seç :
        </Col>
        <Col
          style={{ textAlign: "left", marginBottom: 30 }}
          xl={12}
          lg={12}
          md={12}
          sm={12}
          xs={12}
        >
          <Checkbox
            checked={isFullDigit}
            onChange={(e) => onChangeFullDigit(e.target.checked)}
          />
        </Col>

        <Col xl={2} lg={2} md={2}></Col>

        <Col
          style={{ textAlign: "right", marginBottom: 10 }}
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
        >
          Hesap Hareketleri Anasayfa
        </Col>
        <Col style={{ textAlign: "left" }} xl={2} lg={2} md={2} sm={12} xs={12}>
          <Checkbox
            checked={tableRolesDigit.isDigitHomePage}
            onChange={(e) =>
              onChangeSingleDigit("isDigitHomePage", e.target.checked)
            }
          />
        </Col>

        <Col
          style={{ textAlign: "right" }}
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
        >
          Raporlar/Bayi Durumları
        </Col>
        <Col style={{ textAlign: "left" }} xl={2} lg={2} md={2} sm={12} xs={12}>
          <Checkbox
            checked={tableRolesDigit.isDigitReportFirmStatus}
            onChange={(e) =>
              onChangeSingleDigit("isDigitReportFirmStatus", e.target.checked)
            }
          />
        </Col>
        <Col xl={6} lg={6} md={6}></Col>

        <Col xl={2} lg={2} md={2}></Col>
        <Col
          style={{ textAlign: "right", marginBottom: 10 }}
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
        >
          Hesap İşlemleri/Banka Bakiyeleri
        </Col>
        <Col
          style={{ textAlign: "left", marginBottom: 10 }}
          xl={2}
          lg={2}
          md={2}
          sm={12}
          xs={12}
        >
          <Checkbox
            checked={tableRolesDigit.isDigitBankBalance}
            onChange={(e) =>
              onChangeSingleDigit("isDigitBankBalance", e.target.checked)
            }
          />
        </Col>

        <Col
          style={{ textAlign: "right", marginBottom: 10 }}
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
        >
          Raporlar/Günsonu Raporu
        </Col>
        <Col
          style={{ textAlign: "left", marginBottom: 10 }}
          xl={2}
          lg={2}
          md={2}
          sm={12}
          xs={12}
        >
          <Checkbox
            checked={tableRolesDigit.isDigitReportFromEndOfDay}
            onChange={(e) =>
              onChangeSingleDigit("isDigitReportFromEndOfDay", e.target.checked)
            }
          />
        </Col>
        <Col xl={6} lg={6} md={6}></Col>

        <Col xl={2} lg={2} md={2}></Col>

        <Col
          className={tableRolesDigit.tenantIsKobi ? "gx-text-light" : ""}
          style={{ textAlign: "right", marginBottom: 10 }}
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
        >
          Konsolide Raporlar
        </Col>
        <Col style={{ textAlign: "left" }} xl={2} lg={2} md={2} sm={12} xs={12}>
          <Checkbox
            checked={tableRolesDigit.isDigitConsolidate}
            onChange={(e) =>
              onChangeSingleDigit("isDigitConsolidate", e.target.checked)
            }
          />
        </Col>

        <Col
          style={{ textAlign: "right", marginBottom: 10 }}
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
        >
          Raporlar/Banka Bazlı Hareket
        </Col>
        <Col style={{ textAlign: "left" }} xl={2} lg={2} md={2} sm={12} xs={12}>
          <Checkbox
            checked={tableRolesDigit.isDigitReportTransactionFromBank}
            onChange={(e) =>
              onChangeSingleDigit(
                "isDigitReportTransactionFromBank",
                e.target.checked
              )
            }
          />
        </Col>

        <Col xl={6} lg={6} md={6}></Col>

        <Col xl={2} lg={2} md={2}></Col>

        <Col
          style={{ textAlign: "right", marginBottom: 10 }}
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
        >
          Raporlar/Bakiye Raporu
        </Col>
        <Col style={{ textAlign: "left" }} xl={2} lg={2} md={2} sm={12} xs={12}>
          <Checkbox
            checked={tableRolesDigit.isDigitReportFromBalance}
            onChange={(e) =>
              onChangeSingleDigit("isDigitReportFromBalance", e.target.checked)
            }
          />
        </Col>

        {/* <Col style={{ textAlign: 'right', marginBottom: 10 }} xl={6} lg={6} md={6} sm={12} xs={12}>
          Raporlar/Ay Bazlı Grafik
        </Col> */}
        {/* <Col style={{ textAlign: 'left' }} xl={2} lg={2} md={2} sm={12} xs={12}>
          <Checkbox checked={tableRolesDigit.isDigitChartFromMonth} onChange={(e) => onChangeSingleDigit("isDigitChartFromMonth", e.target.checked)} />
        </Col> */}

        <Col
          style={{ textAlign: "right" }}
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
        >
          Raporlar/Tarih Bazlı Durum
        </Col>
        <Col style={{ textAlign: "left" }} xl={2} lg={2} md={2} sm={12} xs={12}>
          <Checkbox
            checked={tableRolesDigit.isDigitStatusFromDate}
            onChange={(e) =>
              onChangeSingleDigit("isDigitStatusFromDate", e.target.checked)
            }
          />
        </Col>

        <Col xl={6} lg={6} md={6}></Col>

        <Col xl={2} lg={2} md={2}></Col>

        <Col
          style={{ paddingBottom: 60 }}
          xl={24}
          lg={24}
          md={24}
          sm={12}
          xs={24}
        >
          <p style={{ fontSize: "120%" }}>
            <BarsOutlined /> POS RAPOR HAREKETLERİ KOLON GÖSTERİMİ
            <FormItemLabelWithTooltip
              tooltip={
                <>
                  <p>
                    <strong>Seçenek aktif edilirse:</strong>
                    <ul>
                      <li>
                      Pos Hareketleri ekranında ilgili değer/ler detay alanından tabloya geçer. 
                      </li>
                    </ul>
                  </p>
                  <p>
                    <strong>Pasif edilirse:</strong>
                    <ul>
                      <li>
                      Pos Hareketleri ekranında ilgili değer/ler detay alanında görüntülenmeye devam eder.
                      </li>
                    </ul>
                  </p>
                </>
              }
            />
          </p>
        </Col>
        <Col
          style={{ textAlign: "right", marginBottom: 30 }}
          xl={12}
          lg={12}
          md={12}
          sm={12}
          xs={12}
        >
          Tümünü Seç :
        </Col>
        <Col
          style={{ textAlign: "left", marginBottom: 30 }}
          xl={12}
          lg={12}
          md={12}
          sm={12}
          xs={12}
        >
          <Checkbox
            checked={isFullTenantParameter}
            onChange={(e) => onChangeFullTenantParameter(e.target.checked)}
          />
        </Col>
        <Col xl={2} lg={2} md={2}></Col>
        <Col
          style={{ textAlign: "right", marginBottom: 10 }}
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
        >
          Kart Numarası
        </Col>
        <Col style={{ textAlign: "left" }} xl={1} lg={1} md={1} sm={8} xs={8}>
          <Checkbox
            checked={
              tableRolesTenantParameter.isPosTransactionCardNumberShowInColumn
            }
            onChange={(e) =>
              onChangeSingleTenantParameter(
                "isPosTransactionCardNumberShowInColumn",
                e.target.checked
              )
            }
          />
        </Col>

        <Col xl={2} lg={2} md={2}></Col>

        <Col
          style={{ paddingBottom: 60 }}
          xl={24}
          lg={24}
          md={24}
          sm={12}
          xs={24}
        >
          <p style={{ fontSize: "120%" }}>
            <BarsOutlined /> POS TAHSİLAT DEKONT GÖNDERİMİ
            <FormItemLabelWithTooltip
              tooltip={
                <>
                  <p>
                    <strong>Seçenek aktif edilirse:</strong>
                    <ul>
                      <li>
                      B2B &gt; Tahsilat Geçmişi ekranında İşlem Dekontu alanında dekont önizleme yerine email gönderim alanı açılır.
                      </li>
                    </ul>
                  </p>
                  <p>
                    <strong>Pasif edilirse:</strong>
                    <ul>
                      <li>
                      B2B &gt; Tahsilat Geçmişi ekranında İşlem Dekontu alanında dekont önizleme açılır.
                      </li>
                    </ul>
                  </p>
                </>
              }
            />
          </p>
        </Col>

        <Col xl={2} lg={2} md={2}></Col>

        <Col
          style={{ textAlign: "right", marginBottom: 10 }}
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
        >
          Mail ile gönder
        </Col>

        <Col style={{ textAlign: "left" }} xl={2} lg={2} md={2} sm={12} xs={12}>
          <Checkbox
            checked={tableRolesDigit.isReceiptMailSend}
            onChange={(e) =>
              onChangeSingleDigit("isReceiptMailSend", e.target.checked)
            }
          />
        </Col>

        <Col
          style={{ paddingBottom: 60 }}
          xl={24}
          lg={24}
          md={24}
          sm={12}
          xs={24}
        >
          <p style={{ fontSize: "120%" }}>
            <BarsOutlined /> HESAP LİSTESİ PARAMETRELERİ
            <FormItemLabelWithTooltip
              tooltip={
                <>
                  <p>
                    <strong>Seçenek aktif edilirse:</strong>
                    <ul>
                      <li>
                      Hesap Listesi ekranında ilgili değer/ler tabloda detay alanından tabloya geçer.
                      </li>
                    </ul>
                  </p>
                  <p>
                    <strong>Pasif edilirse:</strong>
                    <ul>
                      <li>
                      Hesap Hareketleri ekranında ilgili değer/ler detay alanında görüntülenmeye devam eder.
                      </li>
                    </ul>
                  </p>
                </>
              }
            />
          </p>
        </Col>
        <Col
          style={{ textAlign: "right", marginBottom: 30 }}
          xl={12}
          lg={12}
          md={12}
          sm={12}
          xs={12}
        >
          Tümünü Seç :
        </Col>
        <Col
          style={{ textAlign: "left", marginBottom: 30 }}
          xl={12}
          lg={12}
          md={12}
          sm={12}
          xs={12}
        >
          <Checkbox
            checked={isFullTenantAccount}
            onChange={(e) => onChangeFullTenantAccount(e.target.checked)}
          />
        </Col>

        <Col xl={2} lg={2} md={2}></Col>

        <Col
          style={{ textAlign: "right", marginBottom: 10 }}
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
        >
          Blokeli Bakiye
        </Col>
        <Col style={{ textAlign: "left" }} xl={1} lg={1} md={1} sm={8} xs={8}>
          <Checkbox
            checked={tableRolesTenantAccount.isBlockedBalance}
            onChange={(e) =>
              onChangeSingleTenantAccount("isBlockedBalance", e.target.checked)
            }
          />
        </Col>

        <Col
          style={{ textAlign: "right" }}
          xl={3}
          lg={3}
          md={3}
          sm={14}
          xs={14}
        >
          Kullanılabilir Bakiye
        </Col>
        <Col style={{ textAlign: "left" }} xl={1} lg={1} md={1} sm={8} xs={8}>
          <Checkbox
            checked={tableRolesTenantAccount.isAvailableBalance}
            onChange={(e) =>
              onChangeSingleTenantAccount(
                "isAvailableBalance",
                e.target.checked
              )
            }
          />
        </Col>

        <Col
          style={{ textAlign: "right" }}
          xl={3}
          lg={3}
          md={3}
          sm={14}
          xs={14}
        >
          Kredili Kullanılabilir Bakiye
        </Col>
        <Col style={{ textAlign: "left" }} xl={1} lg={1} md={1} sm={8} xs={8}>
          <Checkbox
            checked={tableRolesTenantAccount.isAvailableCreditBalance}
            onChange={(e) =>
              onChangeSingleTenantAccount(
                "isAvailableCreditBalance",
                e.target.checked
              )
            }
          />
        </Col>

        {/* <Col xl={2} lg={2} md={2}></Col> */}

        <Col
          style={{ paddingBottom: 60 }}
          xl={24}
          lg={24}
          md={24}
          sm={12}
          xs={24}
        >
          <p style={{ fontSize: "120%" }}>
            <BarsOutlined /> ANASAYFA BAKİYE GÖSTERİMİ
            <FormItemLabelWithTooltip
              tooltip={
                <>
                  <p>
                    <strong>Seçenek aktif edilirse:</strong>
                    <ul>
                      <li>
                      Ana sayfa &gt; Hesap Hareketleri ekranında Banka Listesi alanının Kullanılabilir Bakiye bilgisine göre hesaplanmasını sağlar.
                      </li>
                    </ul>
                  </p>
                  <p>
                    <strong>Pasif edilirse:</strong>
                    <ul>
                      <li>
                      Ana sayfa &gt; Hesap Hareketleri ekranında Banka Listesi alanının Bakiye bilgisine göre hesaplanmasını sağlar.
                      </li>
                    </ul>
                  </p>
                </>
              }
            />
          </p>
        </Col>

        <Col xl={2} lg={2} md={2}></Col>

        <Col
          style={{ textAlign: "right", marginBottom: 10 }}
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
        >
          Kullanılabilir Bakiye
        </Col>

        <Col style={{ textAlign: "left" }} xl={2} lg={2} md={2} sm={12} xs={12}>
          <Checkbox
            checked={tableRolesDigit.isHomePageAvailableBalance}
            onChange={(e) =>
              onChangeSingleDigit(
                "isHomePageAvailableBalance",
                e.target.checked
              )
            }
          />
        </Col>
      </Row>
    </div>
  );
};
export default AccountTransactionRole;
